import { render, staticRenderFns } from "./DeliveryCard.vue?vue&type=template&id=5a02fcd6&scoped=true&"
import script from "./DeliveryCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCard.vue?vue&type=style&index=0&id=5a02fcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02fcd6",
  null
  
)

export default component.exports